export default {
  filterPlaceholder: 'Filter by state',
  confirmReset: {
    header: 'Reset state of "{filePathId}"?',
    message: 'The log file is kept and imported again in the next discovery round.',
  },
  resetSelected: 'Reset selected ({count})',
  confirmBulkReset: {
    header: 'Reset state of {count} log files?',
    message: 'The log files are kept and imported again in the next discovery round.',
  },
};
